<template>
  <v-dialog v-model="dialog" max-width="500">
    <v-card>
      <v-card-title>
        <span class="headline">Inserisci Nuova Stagione</span>
      </v-card-title>
      <v-card-text>
        <v-alert v-if="errore_salvataggio" type="error" outlined dense class="mb-3">
          {{ errore_salvataggio }}
        </v-alert>
        <v-form ref="form" v-model="formValid">
          <v-select
            v-model="stagione.id_tipo_stagione"
            :items="tipiStagione"
            item-text="nome"
            item-value="id"
            label="Tipo Stagione"
            :rules="[(v) => !!v || 'Campo obbligatorio']"
            required
            outlined
            :loading="loading_tipi"
            no-data-text="Nessun tipo disponibile"
          />
          <v-select
            v-model="stagione.anno"
            :items="
              Array.from(
                { length: 5 },
                (_, i) => new Date().getFullYear() - 2 + i
              )
            "
            label="Anno Stagione"
            :rules="[(v) => !!v || 'Campo obbligatorio']"
            required
            outlined
          />
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="stagione.dataInizio"
                label="Data Inizio"
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                :rules="[(v) => !!v || 'Campo obbligatorio']"
                required
                outlined
              />
            </template>
            <v-date-picker
              v-model="stagione.dataInizio"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="stagione.dataFine"
                label="Data Fine"
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                :rules="[(v) => !!v || 'Campo obbligatorio']"
                required
                outlined
              />
            </template>
            <v-date-picker
              v-model="stagione.dataFine"
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="closeDialog">Annulla</v-btn>
        <v-btn
          color="primary"
          :loading="loading_save"
          :disabled="!formValid"
          @click="saveStagione"
          >Salva</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
export default {
  name: "NuovaStagioneDialog",
  data() {
    return {
      dialog: false,
      menu: false,
      menu2: false,
      formValid: false,
      errore_salvataggio: "",
      loading_tipi: false,
      stagione: {
        id_tipo_stagione: null,
        anno: null,
        dataInizio: "",
        dataFine: "",
      },
      loading_save: false,
    };
  },
  computed: {
    tipiStagione() {
      return this.$store.getters.getTipiStagione || [];
    },
  },
  methods: {
    openDialog() {
      this.dialog = true;
      if (!this.tipiStagione.length) {
        this.loading_tipi = true;
        this.$store.dispatch("fetchTipiStagione").finally(() => {
          this.loading_tipi = false;
        });
      }
    },
    closeDialog() {
      this.dialog = false;
      this.resetForm();
    },
    async saveStagione() {
      if (!this.$refs.form.validate()) return;
      this.loading_save = true;
      this.errore_salvataggio = "";
      const stagioneToSave = {
        ...this.stagione,
        dataInizio: this.stagione.dataInizio ? moment(this.stagione.dataInizio).unix() : null,
        dataFine: this.stagione.dataFine ? moment(this.stagione.dataFine).unix() : null,
      };
      try {
        const stagione = await this.$store.dispatch("saveStagione", stagioneToSave);
        this.$emit("stagione-creata", stagione);
        this.closeDialog();
      } catch {
        this.errore_salvataggio = "Errore durante il salvataggio. Riprova.";
      } finally {
        this.loading_save = false;
      }
    },
    resetForm() {
      this.stagione = { id_tipo_stagione: null, anno: null, dataInizio: "", dataFine: "" };
      this.errore_salvataggio = "";
      this.$refs.form.resetValidation();
    },
  },
};
</script>

<style scoped>
.headline {
  font-weight: bold;
}
</style>